export async function fetchPortalUserId({ uid, platform, game, signature }) {
  const apiUrl = import.meta.env.VITE_API_URL
  const url = `${apiUrl}cryptography?uid=${uid}&platform=${platform}&game=${game}&token=${signature}`

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })

  if (!response.ok) {
    throw new Error(`portal auth failed: ${response.status} ${response.statusText}`)
  }

  const data = await response.json()
  if (!data.isSuccess) {
    throw new Error('portal auth: isSuccess=false')
  }

  return data.answer
}
